import React, { useState, useContext } from 'react';
import { Typography, Box, Checkbox, Button } from '@mui/material';
import { TextField } from '@platform-ui/design-system';
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';
import { SupportContext } from './SupportContext';

const BaseStyledDiv = styled.div`
  display: flex;
  align-items: center;
`;
const CheckboxStyledDiv = styled(BaseStyledDiv)``;
const FeedbackHeading = styled(BaseStyledDiv)`
  justify-content: space-between;
`;

const FeedbackSubmitButton = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-top: 11px;
`;

const StyledCheckbox = styled(Checkbox)`
  color: ${(props) => (props.checked ? '#0d4ac3' : 'black')};
`;

const OtherCheckBoxInputStyled = styled.div`
  padding-left: '43px';
`;

const VisibleFeedback = ({
  checkboxStates,
  additionalComments,
  handleCheckboxChange,
  handleAdditionalCommentsChange,
  handleSubmit,
  handleClose,
  isSubmitDisabled,
}) => (
  <>
    <FeedbackHeading>
      <Typography variant="subtitle2" sx={{ fontWeight: '600' }}>
        What was the issue with the response?
      </Typography>
      <CloseIcon onClick={handleClose} sx={{ cursor: 'pointer' }} />
    </FeedbackHeading>
    <Box>
      <CheckboxStyledDiv>
        <CheckboxStyledDiv>
          <StyledCheckbox
            onChange={() => handleCheckboxChange('Irrelevant')}
            checked={checkboxStates.Irrelevant}
          />
          <Typography variant="subtitle2">Irrelevant</Typography>
        </CheckboxStyledDiv>
      </CheckboxStyledDiv>
      <CheckboxStyledDiv>
        <StyledCheckbox
          onChange={() => handleCheckboxChange('Inaccurate')}
          checked={checkboxStates.Inaccurate}
        />
        <Typography variant="subtitle2">Inaccurate</Typography>
      </CheckboxStyledDiv>
      <CheckboxStyledDiv>
        <StyledCheckbox
          onChange={() => handleCheckboxChange('Other')}
          checked={checkboxStates.Other}
        />
        <Typography variant="subtitle2">Other (Please specify)</Typography>
      </CheckboxStyledDiv>
      {checkboxStates.Other && (
        <OtherCheckBoxInputStyled>
          <TextField
            dsOnChange={handleAdditionalCommentsChange}
            maxRows={5}
            multiline
            placeholder="Enter additional comments"
            resize="vertical"
            rows={3}
            value={additionalComments}
            wrap="hard"
            fullWidth
          />
        </OtherCheckBoxInputStyled>
      )}
    </Box>
    <FeedbackSubmitButton>
      <Button
        variant="outlined"
        onClick={handleSubmit}
        disabled={isSubmitDisabled}
        sx={{
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid #0000006b',
          textTransform: 'capitalize',
          '&:hover': {
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid #0000006b',
          },
        }}
      >
        Submit
      </Button>
    </FeedbackSubmitButton>
  </>
);

const InvisibleFeedback = ({ isSubmitDisabled }) =>
  isSubmitDisabled ? null : (
    <Typography variant="subtitle2">
      Thanks for helping Zuora AI improve!
    </Typography>
  );

const ChatBotFeedbackNegative = ({ onCheckboxChange }) => {
  const { handleFeedbackSubmission } = useContext(SupportContext);
  const [additionalComments, setAdditionalComments] = useState('');
  const [checkboxStates, setCheckboxStates] = useState({
    Irrelevant: false,
    Inaccurate: false,
    Other: false,
  });
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleCheckboxChange = (comment) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [comment]: !prevState[comment],
    }));
    onCheckboxChange({
      comments:
        comment === 'Other'
          ? additionalComments
          : comment === 'Irrelevant'
          ? 'Irrelevant'
          : comment === 'Inaccurate'
          ? 'Inaccurate'
          : '',
    });
  };

  const handleAdditionalCommentsChange = (e) => {
    setAdditionalComments(e.target.value);
    if (checkboxStates.Other) {
      onCheckboxChange({ comments: 'Other: ' + e.target.value });
    }
  };

  const handleSubmit = () => {
    setIsVisible(false);
    handleFeedbackSubmission();
  };

  return isVisible ? (
    <VisibleFeedback
      checkboxStates={checkboxStates}
      additionalComments={additionalComments}
      handleCheckboxChange={handleCheckboxChange}
      handleAdditionalCommentsChange={handleAdditionalCommentsChange}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      isSubmitDisabled={!Object.values(checkboxStates).some((value) => value)}
    />
  ) : (
    <InvisibleFeedback
      isSubmitDisabled={!Object.values(checkboxStates).some((value) => value)}
    />
  );
};

export default ChatBotFeedbackNegative;
